import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import SoompiApp from 'scripts/components/SoompiApp'
import cookie from 'react-cookies'
import ClientErrors from 'scripts/lib/ClientErrors'
import Loadable from 'react-loadable'
import {routes} from 'scripts/routes'
import { matchRoutes } from 'react-router-config'
import locale from 'parent/i18n/react'
import Constants from 'scripts/base/Constants'

import FontFaceObserver from 'fontfaceobserver'
import { Provider } from 'scripts/store'
import '../scss/style.scss'
import '../../favicon.ico'
import '../../ads.txt'
import '../../BingSiteAuth.xml'

const oswald = new FontFaceObserver('oswald')
const lato = new FontFaceObserver('lato')
const isFontLoaded = cookie.load('fontsLoaded')
const { match } = matchRoutes(routes, window.location.pathname)[0]

if (match && match.params['lang']) {
  locale.setLanguage(match.params['lang'])
} else {
  locale.setLanguage(Constants.DefaultLang)
}
if (!isFontLoaded) {
  Promise.all([
    oswald.load(),
    lato.load()
  ]).then(function() {
    document.documentElement.className += ' fonts-loaded'
    const expires = new Date()
    expires.setDate(expires.getDate() + 7)
    cookie.save('fontsLoaded', true, { path: '/', secure: false, httpOnly: false, expires: expires })
  }, function(error) {
    ClientErrors({
      message: 'font is not available at this time, so we are using fallback fonts instead',
      error: error
    })
  })
}

const mountNode = document.getElementById('app')

Loadable.preloadReady().then(() => {
  ReactDOM.hydrate(
    <Provider>
      <BrowserRouter>
        <SoompiApp locale={locale}/>
      </BrowserRouter>
    </Provider>,
    mountNode
  )
})



// WEBPACK FOOTER //
// ./assets/js/client.jsx